import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import { Box, Flex } from '../grid';
import { Icon } from '../icons';
import { P } from '../typography/new';

const Accordion = ({ title, defaultExpanded, onStateChange, children, disabled, ...rest }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleOnClick = () => {
    setExpanded(!expanded);
    onStateChange(expanded);
  };

  return (
    <div>
      <SummaryWrapper
        py="28px"
        pb={expanded ? '20px' : '28px'}
        alignItems="center"
        justifyContent="space-between"
        onClick={handleOnClick}
        disabled={disabled}
        gap="12px"
        {...rest}
      >
        <P variant="medium-semi-bold">{title}</P>
        <Icon
          name="chevron"
          height="24px"
          width="24px"
          minHeight="24px"
          minWidth="24px"
          rotate={expanded ? '180deg' : '0'}
        />
      </SummaryWrapper>
      {expanded && (
        <Box style={{ wordBreak: 'break-word' }} mb={{ xs: '28px', md: '40px' }}>
          {children}
        </Box>
      )}
    </div>
  );
};

const SummaryWrapper = styled(Flex)`
  ${({ disabled }) => !disabled && `cursor: pointer;`}

  ${({ disabled, theme }) =>
    disabled &&
    css`
      color: ${theme.colors.grey300};
      cursor: not-allowed;
      pointer-events: none;

      svg {
        fill: ${theme.colors.grey300};
      }
    `}
`;

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  defaultExpanded: PropTypes.bool,
  disabled: PropTypes.bool,
  onStateChange: PropTypes.func,
  title: PropTypes.string.isRequired,
};

Accordion.defaultProps = {
  defaultExpanded: false,
  disabled: false,
  onStateChange: noop,
};

export { Accordion };
